/* eslint-disable max-lines */
import { CALL_API } from '../middleware/api';
import * as types from '../constants/ActionTypes';
/**
 * Action creator for updating information about logged user.
 *
 * @param data Object
 * @returns {function(Function, Function)}
 */
export const updateLoggedUser = (data) => (dispatch, getState) => {
    return dispatch({
        [CALL_API]: {
            types: [types.UPDATE_LOGIN_USER_DETAILS_REQUEST, types.UPDATE_LOGIN_USER_DETAILS_SUCCESS, types.UPDATE_LOGIN_USER_DETAILS_FAILURE],
            endpoint: `/auth/me`,
            method: 'POST',
            data: data,
            token: getState().user.token,
        },
    });
};
/**
 * Action creator for log user out.
 *
 * @returns {function(Function, Function)}
 */
export const logoutUser = () => (dispatch, getState) => {
    return dispatch({
        [CALL_API]: {
            types: [types.LOGOUT_REQUEST, types.LOGOUT_SUCCESS, types.LOGOUT_FAILURE],
            endpoint: `/auth/logout`,
            method: 'GET',
            token: getState().user.token,
        },
    });
};
export const getOrganizations = () => (dispatch, getState) => {
    return dispatch({
        [CALL_API]: {
            types: [types.GET_ORGANIZATIONS_REQUEST, types.GET_ORGANIZATIONS_SUCCESS, types.GET_ORGANIZATIONS_FAILURE],
            endpoint: `/organizations`,
            method: 'GET',
            token: getState().user.token,
        },
    });
};
export const getOrganizationDetail = (name) => (dispatch, getState) => {
    return dispatch({
        [CALL_API]: {
            types: [types.GET_ORGANIZATION_DETAIL_REQUEST, types.GET_ORGANIZATION_DETAIL_SUCCESS, types.GET_ORGANIZATION_DETAIL_FAILURE],
            endpoint: `/organizations/${name}`,
            method: 'GET',
            token: getState().user.token,
        },
    });
};
export const addOrganization = (data) => (dispatch, getState) => {
    return dispatch({
        [CALL_API]: {
            types: [types.ADD_ORGANIZATION_REQUEST, types.ADD_ORGANIZATION_SUCCESS, types.ADD_ORGANIZATION_FAILURE],
            endpoint: `/organizations`,
            method: 'POST',
            data: data,
            token: getState().user.token,
        },
    });
};
export const updateOrganization = (name, data) => (dispatch, getState) => {
    return dispatch({
        [CALL_API]: {
            types: [types.UPDATE_ORGANIZATION_REQUEST, types.UPDATE_ORGANIZATION_SUCCESS, types.UPDATE_ORGANIZATION_FAILURE],
            endpoint: `/organizations/${name}`,
            method: 'PUT',
            data: data,
            token: getState().user.token,
        },
    });
};
export const addOrganizationMember = (name, email) => (dispatch, getState) => {
    return dispatch({
        [CALL_API]: {
            types: [types.ADD_ORGANIZATION_MEMBER_REQUEST, types.ADD_ORGANIZATION_MEMBER_SUCCESS, types.ADD_ORGANIZATION_MEMBER_FAILURE],
            endpoint: `/organizations/${name}/members`,
            method: 'POST',
            data: {
                email: email,
            },
            token: getState().user.token,
        },
    });
};
export const removeOrganizationMember = (name, userId) => (dispatch, getState) => {
    return dispatch({
        [CALL_API]: {
            types: [types.REMOVE_ORGANIZATION_MEMBER_REQUEST, types.REMOVE_ORGANIZATION_MEMBER_SUCCESS, types.REMOVE_ORGANIZATION_MEMBER_FAILURE],
            endpoint: `/organizations/${name}/members/${userId}`,
            method: 'DELETE',
            token: getState().user.token,
        },
    });
};
export const finishInvitation = (token) => (dispatch, getState) => {
    return dispatch({
        [CALL_API]: {
            types: [types.FINISH_INVITATION_REQUEST, types.FINISH_INVITATION_SUCCESS, types.FINISH_INVITATION_FAILURE],
            endpoint: `/organizations/invitations`,
            method: 'POST',
            data: {
                token: token,
            },
            token: getState().user.token,
        },
    });
};
export const removeOrganizationInvite = (name, email) => (dispatch, getState) => {
    return dispatch({
        [CALL_API]: {
            types: [types.REMOVE_ORGANIZATION_INVITE_REQUEST, types.REMOVE_ORGANIZATION_INVITE_SUCCESS, types.REMOVE_ORGANIZATION_INVITE_FAILURE],
            endpoint: `/organizations/${name}/invitations`,
            method: 'DELETE',
            data: {
                email: email,
            },
            token: getState().user.token,
        },
    });
};
export const getBillingPlans = () => (dispatch, getState) => {
    return dispatch({
        [CALL_API]: {
            types: [types.GET_BILLING_PLANS_REQUEST, types.GET_BILLING_PLANS_SUCCESS, types.GET_BILLING_PLANS_FAILURE],
            endpoint: `/billing/plans`,
            method: 'GET',
            token: getState().user.token,
        },
    });
};
export const changeBillingPlan = (planId, annuallyPayment) => (dispatch, getState) => {
    return dispatch({
        [CALL_API]: {
            types: [types.CHANGE_BILLING_PLAN_REQUEST, types.CHANGE_BILLING_PLAN_SUCCESS, types.CHANGE_BILLING_PLAN_FAILURE],
            endpoint: `/auth/billing/plan`,
            method: 'POST',
            data: {
                planId: planId,
                annuallyPayment: annuallyPayment,
            },
            token: getState().user.token,
        },
    });
};
export const payPlan = (annuallyPayment) => (dispatch, getState) => {
    return dispatch({
        [CALL_API]: {
            types: [types.PAY_PLAN_REQUEST, types.PAY_PLAN_SUCCESS, types.PAY_PLAN_FAILURE],
            endpoint: `/auth/billing/plan/pay`,
            method: 'POST',
            data: {
                annuallyPayment: annuallyPayment,
            },
            token: getState().user.token,
        },
    });
};
export const activateTrial = () => (dispatch, getState) => {
    return dispatch({
        [CALL_API]: {
            types: [types.ACTIVATE_TRIAL_REQUEST, types.ACTIVATE_TRIAL_SUCCESS, types.ACTIVATE_TRIAL_FAILURE],
            endpoint: `/auth/billing/trial`,
            method: 'POST',
            token: getState().user.token,
        },
    });
};
export const getInvoices = () => (dispatch, getState) => {
    return dispatch({
        [CALL_API]: {
            types: [types.GET_INVOICES_REQUEST, types.GET_INVOICES_SUCCESS, types.GET_INVOICES_FAILURE],
            endpoint: `/billing/invoices`,
            method: 'GET',
            token: getState().user.token,
        },
    });
};
export const getCustomerPortalUrl = () => (dispatch, getState) => {
    return dispatch({
        [CALL_API]: {
            types: [types.CUSTOMER_PORTAL_REQUEST, types.CUSTOMER_PORTAL_SUCCESS, types.CUSTOMER_PORTAL_FAILURE],
            endpoint: '/auth/billing/customer-portal',
            method: 'GET',
            token: getState().user.token,
        },
    });
};
